export default "CREATE INDEX `last_used_at_idx` ON `chat_settings` (`last_used_at`);"